import * as React from 'react';
import * as Styled from './Copy.style'

const Copy: React.FC<{}> = (props) => (
    <Styled.Flex justifyContent="center" m="40px auto"><div>{props.children}</div></Styled.Flex>
);

export default Copy;